/* eslint-disable import/prefer-default-export, react/prop-types */

export const wrapRootElement = ({ element }, options) => {
	return element;
};

export const wrapPageElement = ({ element, props }, options) => {
	return element;
};
